import User from "./data/user/index";
import home from "./data/home/index";
import order from "./data/order/index";
import money from "./data/money/index";

const en = {
  language: {
    name: "中文",
  },
  user: {
    login: User.Login.EN,
    register: User.Register.EN,
  },
  home: {
    homePage: home.homePage.EN,
    baoguo: home.baoguo.EN,
    yunfei: home.yunfei.EN,
    my: home.my.EN,
  },
  order: {
    orders: order.orders.EN,
    packages: order.packages.EN,
    other: order.other.EN,
  },
  money: {
    amount: money.amount.EN,
    JY: money.JY.EN,
  },
};
export default en;
